import { Navigation } from "swiper";
import { Add, ArrowRight } from "@mui/icons-material";
import { Fragment, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { useDispatch, useSelector } from "react-redux";
import { MdEdit } from "react-icons/md";
import { Avatar, MenuItem, Typography } from "@mui/material";
import { MdOutlineCancel } from "react-icons/md";
import { FaRegQuestionCircle } from "react-icons/fa";
import { FaRegCheckCircle } from "react-icons/fa";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import pages from "../../../constants/pages";
import { TextField } from "../../../components";
import { signInMember } from "../../../redux/slices/memberSlice";
import { PrimaryLoadingButton } from "../../css components/Button";
import { colors } from "../../css components/Style";

const Image = styled.div`
  margin-top: 20px;
  height: 180px;
  width: 180px;
  display: flex;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
`;

export default function SelectRole({
  currentBrand,
  setCurrentBrand,
  businessEntityID,
  brands,
  userID,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const authToken =
    useSelector((state) => state?.memberDetails.authToken) ||
    sessionStorage.getItem("authToken");

  const role =
    useSelector((state) => state?.memberDetails.role) ||
    sessionStorage.getItem("role");

  const { dashboardState } = useSelector((state) => state.memberDetails);

  const [isBrandVerified, setBrandVerification] = useState();

  const [userDashboardState, setUserDashboardState] = useState(
    dashboardState === "NORMAL_USER" ? dashboardState : "monetization"
  );

  return (
    <Fragment>
      <div className="outer-brand-div">
        <div className="select-brand-div">
          {brands.length > 0 && (
            <Fragment>
              <Swiper
                initialSlide={0}
                slidesPerView={3}
                spaceBetween={16}
                navigation={true}
                modules={[Navigation]}
                className="mySwiper"
              >
                {brands.map((brand) => (
                  <SwiperSlide
                    key={brand.ID}
                    style={{
                      borderColor:
                        currentBrand.ID === brand.ID && colors.sprintexBlue,
                    }}
                  >
                    <Image
                      style={{
                        opacity:
                          (brand.isBrandVerified === 0 ||
                            brand.isBrandVerified === 2) &&
                          0.4,
                      }}
                      onClick={() => {
                        setBrand(brand.ID, brand.brandName, brand.brandType);
                        setBrandVerification(brand.isBrandVerified);
                      }}
                    >
                      <img
                        className="img-logo"
                        style={{
                          cursor: "pointer",
                          border:
                            currentBrand.ID === brand.ID &&
                            `1px solid ${colors.sprintexBlue}`,
                        }}
                        src={brand.logo}
                        alt="logo"
                      />
                      <div className="outer-brand-status">
                        <div
                          style={{
                            background:
                              brand.isBrandVerified === 0
                                ? colors.warning
                                : brand.isBrandVerified === 1
                                ? colors.green
                                : colors.error,
                          }}
                          className="brand-status"
                        >
                          {brand.isBrandVerified === 0 && (
                            <Fragment>
                              <FaRegQuestionCircle
                                color="#fff"
                                fontSize={"15px"}
                              />
                              &nbsp;
                              <span>{"Unverified"} </span>
                            </Fragment>
                          )}

                          {brand.isBrandVerified === 2 && (
                            <Fragment>
                              <MdOutlineCancel color="#fff" fontSize={"15px"} />
                              &nbsp;
                              <span>{"Rejected"} </span>
                            </Fragment>
                          )}

                          {brand.isBrandVerified === 1 && (
                            <Fragment>
                              <FaRegCheckCircle
                                color="#fff"
                                fontSize={"15px"}
                              />
                              &nbsp;
                              <span>{"Approved"} </span>
                            </Fragment>
                          )}
                        </div>
                      </div>

                      <Typography className="brand-name">
                        {brand.brandName}
                      </Typography>
                    </Image>

                    {brand.isBrandVerified === 0 && (
                      <div
                        className="edit-icon"
                        onClick={() =>
                          navigate(
                            pages.brandDetailEmpty.route +
                              "?brandID=" +
                              brand.ID
                          )
                        }
                      >
                        <MdEdit fontSize="15px" color={colors.sprintexBlue} />
                      </div>
                    )}
                  </SwiperSlide>
                ))}
              </Swiper>
            </Fragment>
          )}

          {brands.length === 0 && (
            <div onClick={() => addNewBrand()} className="add-new-brand">
              <Avatar
                style={{
                  background: colors.sprintexBlue,
                  margin: "auto",
                  width: "35px",
                  height: "35px",
                }}
              >
                <Add style={{ height: "28px", width: "25px" }} />
              </Avatar>
              <Typography
                style={{
                  marginLeft: "10px",
                  textAlign: "center",
                  display: "flex",
                  alignSelf: "center",
                }}
                variant="subtitle1"
                color={colors.green}
              >
                Add New Brand
              </Typography>
            </div>
          )}
        </div>

        <div className="bottom-div">
          {brands.length > 0 && (
            <PrimaryLoadingButton
              style={{ float: "right" }}
              type="submit"
              variant="contained"
              endIcon={<ArrowRight fontSize="20px" />}
              disabled={
                isBrandVerified === 2 ||
                isBrandVerified === 0 ||
                !currentBrand.ID
              }
              onClick={async () => {
                if (role === "AGENCY") {
                }
                sessionStorage.setItem("role", "NORMAL_USER");
                localStorage.setItem(
                  "dashboardState" + currentBrand.ID,
                  userDashboardState
                );
                await dispatch(
                  signInMember({
                    authToken: authToken,
                    userID: userID,
                    businessEntityId: businessEntityID,
                    brandType: currentBrand.type,
                  })
                );

                navigate(pages.brandDetails.route);
              }}
            >
              Continue
            </PrimaryLoadingButton>
          )}
        </div>
      </div>
    </Fragment>
  );

  async function addNewBrand() {
    localStorage.setItem("dashboardState" + currentBrand.ID, "monetization");
    navigate(pages.brandDetailCreateEmpty.route + "?newMultiBrand=" + true);
  }

  function setBrand(ID, name, type) {
    if (type === 2) {
      setUserDashboardState("monetization");
    }
    if (type === 3) {
      setUserDashboardState("promotion");
    }

    setCurrentBrand({
      ID: ID,
      name: name,
      type: type,
    });
    sessionStorage.setItem("activeBrand", ID);
    sessionStorage.setItem("brandType", type);
  }

  function setDashboardUser(e) {
    setUserDashboardState(e.target.value);
  }
}
